import { useViewport } from "src/common/hooks/ViewPort";
import { useState } from "react";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ToggleBtn } from "src/components/atoms/ToggleButton/ToggleBtn";

interface ModalProps {
  onClose: () => void;
}

export const ModalWalkDevice = ({ onClose }: ModalProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { px } = useViewport();

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "45rem",
        height: "100%",
        maxHeight: "100vh",
        position: "fixed",
        left: "50%",
        top: 0,
        transform: "translateX(-50%)",
        background: "#F9FAFB",
        zIndex: 999,
        padding: "0 16px",
      }}
    >
      {/* 헤더 */}
      <SubConHeader title="건강 정보 설정" onClickArrow={() => onClose()} />

      {/* 폼 카드 */}
      <div
        style={{
          marginTop: px(12),
          background: "#FFFFFF",
          borderRadius: px(14),
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
          padding: px(14),
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#000",
            fontSize: px(16),
            fontWeight: 700,
            lineHeight: `${px(24)}px`,
          }}
        >
          건강 정보 연동
        </div>
        <ToggleBtn isActive={isActive} setIsActive={setIsActive} />
      </div>
    </div>
  );
};
